export const VERTICAL_Y_AXIS_WIDTH = 120;
